var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import { ActivityBlockWrapper } from "../../styled/styled";
import { StyledCard } from "../../../../containers/ReportingV2/styled";
import ActivityItem from "../../DataItem";
var Wrapper = styled(StyledCard)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 30px;\n"], ["\n  margin-bottom: 30px;\n"])));
var PlatformActivityBlock = /** @class */ (function (_super) {
    __extends(PlatformActivityBlock, _super);
    function PlatformActivityBlock() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PlatformActivityBlock.prototype.render = function () {
        var _a = this.props.platformActivity, logged_in_rate = _a.logged_in_rate, assigned_licenses = _a.assigned_licenses, logged_in_users = _a.logged_in_users;
        return (React.createElement(Wrapper, null,
            React.createElement(ActivityBlockWrapper, null,
                React.createElement(ActivityItem, { dataItem: logged_in_rate, isPercentage: true, bold: true, label: "admin.reportingV2.acitivityBlock.loggedInRate", toolTipText: "admin.reportingV2.acitivityBlock.toolTip.loggedInRate" }),
                React.createElement(ActivityItem, { dataItem: assigned_licenses, label: "admin.reportingV2.acitivityBlock.assingedLicenses", toolTipText: "admin.reportingV2.acitivityBlock.toolTip.assingedLicenses" }),
                React.createElement(ActivityItem, { dataItem: logged_in_users, label: "admin.reportingV2.acitivityBlock.loggedIn", toolTipText: "admin.reportingV2.acitivityBlock.toolTip.loggedIn" }))));
    };
    return PlatformActivityBlock;
}(PureComponent));
export default PlatformActivityBlock;
var templateObject_1;
